export default __webpack_public_path__ + "static/media/post8.70e1ad24.jpg";